module.exports = __webpack_public_path__ + "img/pet_exchange.f442e756.svg";